import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {AuthService} from '../auth.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertService} from '../alert.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass']
})
export class LoginComponent implements OnInit {

  form: FormGroup
  authError: any
  message: string

  constructor(public auth: AuthService, private router: Router, private route: ActivatedRoute, public alert: AlertService) { }

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      if (params['loginAgain']) {
        this.alert.warning('Доступ запрещен. Авторизуйтесь!');
      }
    })

    this.form = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email]),
      password: new FormControl(null, [Validators.required, Validators.minLength(6)])
    });
    this.auth.eventAuthError$.subscribe(data => {
      this.authError = data;
    });
  }

  login(loginForm: FormGroupDirective) {
    if (this.form.invalid) {
      return;
    }
    this.auth.login(this.form.value.email, this.form.value.password);
  }

}
